<template>
  <div id="sub-address" class="sub-address">   
    <Dropdown
        v-if="theme !== 'tuktuk'"
        :selected="district"
        @change="(val) => district = val"
        :placeholder="placeholder"
        :rules="rules"
        :options="options"
        :label="showLabel ? fieldLabel : undefined"
        :name="fieldLabel"
        @opened="debouncedFocusAndFetch();"
        :use-bottom-sheet="$device ? $device.isMobile : false"
        :bottomSheetTitle="`Pilih ${fieldLabel}`"
        bottomSheetClass="bottom-sheet__sub-address-fill"
        :required="(rules || '').includes('required')"
    >
        <template #trigger="{ displayedValue }">
            <span>{{ displayedValue }}</span>
        </template>
        <template #before-items>
            <Input ref='orderInput' class='device-ios w-100' v-model="searchData" type="text" />
        </template>
        <template #after-items>
            <span v-if="options.length === 0" class="address-search-placeholder">
                {{ autofillLoading
                    ? 'Searching...'
                    : searchData
                      ? 'Data tidak ditemukan'
                      : 'Ketik nama Kota/Kabupaten (minimal 4 huruf)'
                }}
            </span>
        </template>
    </Dropdown>
    <template v-if="theme === 'tuktuk'">
    <div
      :class="{
        'selected-address' : isLabel == 'showLabel', 
        'placeholder-text' : district == ''
      }"
      class="select-value-label"
    >
      {{ district || placeholder }}
    </div>
    <vs-select
      class="vs-form-control"
      @click="debouncedFocusAndFetch();"
      :class="className"
      v-model="district"
    >  
      <vs-input
        ref="orderInput"
        class="device-ios"
        v-model="searchData"
        type="text"
      />
      <empty
        v-if="autofillLoading"
        :classProp="'p-1'"
        :data="'Searching'"
      />
      <empty
        v-else-if="AutofillData.length < 1"
        :classProp="'p-1'"
        :data="'Data tidak ditemukan'"
      />
      <vs-option
        :key="opt._id+'_'+opt.DISTRICT_NAME"
        v-for="opt in AutofillData"
        :label="opt.DISTRICT_NAME"
        :value="opt._id"
      >
        {{ opt.DISTRICT_NAME }}
      </vs-option>
    </vs-select>
    </template>
  </div>
</template>

<script>
import Dropdown from "@/components/Form/components/classic-form-input/dropdown.vue";
import Input from "@/components/Form/components/classic-form-input/input.vue";
import Empty from '../empty.vue'
import config from "./../../config.js";
import axios from "axios";
import debounce from "lodash/debounce";

export default {
  name: "DistrictAddress",
  components: {
    Dropdown,
    Input,
    Empty
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    province: {
      type: String,
      default: ""
    },
    city: {
      type: String,
      default: ""
    },
    fieldLabel: {
      type: String,
      default: "Alamat"
    },
    rules: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Pilih Alamat"
    },
    theme: {
      type: String,
      default: "default"
    },
    className: {
      type: Object,
      default: () => ({})
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    isLabel: {
      type: String,
      default: ""
    },
    shippingData: {
      type: Object,
      default: () => ({})
    },
    requiresSubdistrict: {
      type: Boolean,
      default: false
    },
    hasSubdistrictField: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      baseUrl: config.api.replace("/api", ""),
      searchData: "",
      autofillLoading: false,
      AutofillData: []
    };
  },
  methods: {
    resetOption() {
      this.AutofillData = []
    },
    focusFields() {
      setTimeout(() => {
        this.$refs.orderInput &&
          this.$refs.orderInput.$el.querySelector("input").focus();
      }, 200)
    },
    async fetchData() {
      const keyword = this.searchData ? this.searchData.trim() : "";

      if (keyword.length < 4 && keyword.length != 0) {
        this.AutofillData = [];
        this.autofillLoading = false;
        return;
      }

      const params = { province: this.province, city: this.city, search: {key: 'DISTRICT_NAME', value: keyword} };
      const city = [], district = [], province = [];

      if (
        this.shippingData &&
        this.shippingData.enableExcludeShipping &&
        Array.isArray(this.shippingData.excludeShippingLocation)
      ) {
        this.shippingData.excludeShippingLocation.forEach(item => {
          if (item.type === 'province') {
            province.push(item.PROVINCE_NAME);
          } else if (item.type === 'city') {
            city.push(item.item.CITY_NAME);
          } else if (item.type === 'district') {
            district.push(item.item.DISTRICT_NAME);
          }
        });

        Object.assign(params, {
          province_filter: province.join(","),
          city_filter: city.join(","),
          district_filter: district.join(","),
          excludeShipping: this.shippingData.excludeShipping,
          excludeShippingLocation: this.shippingData.excludeShippingLocation,
        });
      }

      this.autofillLoading = true;

      try {
        const { data } = await axios.post(
          `${this.baseUrl}api/address/getAddress`,
          params
        );
        this.AutofillData = data.success ? data.data.sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME)) : [];
      } catch (err) {
        console.error("Error fetching autofill:", err);
        this.AutofillData = [];
      } finally {
        this.autofillLoading = false;
      }
    },
    debouncedFocusAndFetch: debounce(function () {
      this.focusFields();
      this.fetchData();
    }, 300)
  },
  watch: {
    searchData: {
      handler: debounce(function () {
        this.fetchData();
      }, 300),
      immediate: false
    }
  },
  computed: {
    options() {
      return this.AutofillData.map(opt => ({
        label: opt.DISTRICT_NAME,
        value: opt._id,
      }))
    },
    district: {
      get() {
        return this.value;
      },
      set(val) {
        const selectedData = this.AutofillData.find(data => String(data._id) == String(val));
        if(selectedData) {
          // The district is the destination unless the buyer still has to pick a village.
          const useDistrictAsDestination = !this.requiresSubdistrict;
          // Prefill the village only when it is not shown as its own field.
          const fillHiddenLevels = !this.hasSubdistrictField;
          const payload = {
            customerAUTOFILL: useDistrictAsDestination ? selectedData._id : '',
            customerFULL_AUTOFILL: `${selectedData.PROVINCE_NAME}, ${selectedData.CITY_NAME}, ${selectedData.DISTRICT_NAME}`,
            PROVINCE: selectedData.PROVINCE_NAME,
            DISTRICT: selectedData.DISTRICT_NAME,
            CITY: selectedData.CITY_NAME,
            SUBDISTRICT: fillHiddenLevels ? selectedData.SUBDISTRICT_NAME : '',
            ZIP: fillHiddenLevels ? selectedData.ZIP_CODE : '',
            ORIGIN_CODE: useDistrictAsDestination ? selectedData.ORIGIN_CODE : '',
            CODE_SAP: useDistrictAsDestination ? selectedData.CODE_SAP : '',
            DESTINATION_CODE_SI: useDistrictAsDestination ? selectedData.DESTINATION_CODE_SI : '',
            DESTINATION_CODE: useDistrictAsDestination ? selectedData.DESTINATION_CODE : '',
            ORIGIN_CODE_SI: useDistrictAsDestination ? selectedData.ORIGIN_CODE_SI : '',
            closedSi: useDistrictAsDestination ? selectedData.closedSi : '',
            unsupportedSi: useDistrictAsDestination ? selectedData.unsupportedSi : '',
            CITY_NAME_SI: useDistrictAsDestination ? selectedData.CITY_NAME_SI : '',
          };
          this.$emit('onChange', payload);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-address {
  scroll-margin: 150px;

  &::v-deep {
    .classic-form__dropdown {
      label {
        opacity: 1 !important;
      }
      .classic-form__input {
          input {
              font-size: 14px !important;
              height: 40px !important;
              padding: 10px 36px 10px 12px !important;
              background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.1057 14.688L17 17.488M16.0667 10.0214C16.0667 13.6296 13.1416 16.5547 9.53333 16.5547C5.92507 16.5547 3 13.6296 3 10.0214C3 6.41311 5.92507 3.48804 9.53333 3.48804C13.1416 3.48804 16.0667 6.41311 16.0667 10.0214Z' stroke='%236C7E95' stroke-linecap='round'/%3E%3C/svg%3E%0A") !important;
              background-position: right 12px top 10px !important;
              background-repeat: no-repeat !important;
              outline-color: #E0E9F4 !important;
              outline-width: 1px !important;
              outline-offset: -1px !important;
              box-shadow: 0px 1px 2px 0px #1018280D;
          }
      }
      .address-search-placeholder {
          margin-top: 6px;
          color: #6C7E95;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
      }
    }
  }
}
.placeholder-text {
  opacity: 0.4;
}
</style>

<style lang="scss">
.bottom-sheet__sub-address-fill {
    .classic-form__input {
      input {
        font-size: 14px !important;
        height: 40px !important;
        padding: 10px 36px 10px 12px !important;
        background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.1057 14.688L17 17.488M16.0667 10.0214C16.0667 13.6296 13.1416 16.5547 9.53333 16.5547C5.92507 16.5547 3 13.6296 3 10.0214C3 6.41311 5.92507 3.48804 9.53333 3.48804C13.1416 3.48804 16.0667 6.41311 16.0667 10.0214Z' stroke='%236C7E95' stroke-linecap='round'/%3E%3C/svg%3E%0A") !important;
        background-position: right 12px top 10px !important;
        background-repeat: no-repeat !important;
        outline-color: #E0E9F4 !important;
        outline-width: 1px !important;
        outline-offset: -1px !important;
        box-shadow: 0px 1px 2px 0px #1018280D;

        &:focus {
          outline-color: #E0E9F4 !important;
        }
      }
    }
    .address-search-placeholder {
        margin-top: 6px;
    }
}
</style>
